export enum OwningTeam {
	Unassigned = 'unassigned',
	AifcFoundations = 'AIFC Foundations',
	EditorAi = 'Editor AI',
	RovoChat = 'Rovo Chat',
	Whiteboards = 'Whiteboards',
	Databases = 'Databases',
	JiraAifc = 'Jira AIFC',
	GravityAi = 'Gravity-AI',
	Pulsar = 'Pulsar',
	RovoAgents = 'rovo-agents-fe',
	CsmAi = 'CSM AI',
	CcCeMau = 'CC CE MAU',
	RovoExpansion = 'Rovo Expansion',
	JiraWarepil = 'jira-warepil',
	JsmGrapeSoju = 'jsm-grape-soju',
}
